import { BreadcrumbItem, Breadcrumbs } from '@wonderschool/common-base-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteNameEnum, useRoutes } from '../../../navigation';

export function StudentEditPageBreadcrumbs() {
  const { t } = useTranslation();
  const { gotoRouteByName } = useRoutes();

  const memoedTranslations: BreadcrumbItem[] = useMemo(
    () => [
      {
        label: t('students.breadcrumbs.list'),
        callback: () => {
          gotoRouteByName(RouteNameEnum.STUDENTS);
        },
      },
      { label: t('student.editPage.breadcrumb.studentProfile'), isCurrentLevel: true },
    ],
    [t, gotoRouteByName]
  );

  return <Breadcrumbs items={memoedTranslations} />;
}
